export const useIsBot = () => {
  // Only attempt this on the server
  if (import.meta.client) return false

  const event = useRequestEvent()
  const ua = event?.node.req.headers['user-agent'] || ''
  // Regex for common search bots
  const botPattern = /googlebot|bingbot|yandex|baiduspider|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora\ link\ preview|showyoubot|outbrain|pinterest\/0\.|zeitgeist|duckduckbot/i

  return botPattern.test(ua)
}
